export class UpdateWorkspaceMetricsSettingsInputAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudwatchEnabled",
            "baseName": "cloudwatchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchMetricNamespace",
            "baseName": "cloudwatchMetricNamespace",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceMetricsSettingsInputAws.attributeTypeMap;
    }
    constructor() {
    }
}
